module.exports = __webpack_public_path__ + "static/our-happy-client-ad6ee7965b74aca88f0f6c5f94261ce0.png";